import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaTwitter, FaPinterestP, FaTumblr } from 'react-icons/fa';

const SocialIcons = ({ className }) => (
  <div className={className}>
    <a href="https://www.instagram.com/artrewards/" target="_blank" rel="noopener noreferrer"title="instagram" aria-label="Instagram" className="text-gray-500 hover:text-white transition-colors">
      <FaInstagram className="text-lg" />
    </a>
    <a href="https://www.facebook.com/artrewards" target="_blank" aria-label="Facebook"  title="Facebook" className="text-gray-500 hover:text-white transition-colors">
      <FaFacebookF className="text-lg" />
    </a>
    <a href="https://www.linkedin.com/company/artsrewards/" aria-label="LinkedIn" title="LinkedIn" target="_blank" className="text-gray-500 hover:text-white transition-colors">
      <FaLinkedinIn className="text-lg" />
    </a>
    <a href="https://x.com/artrewards" aria-label="X" target="_blank" title="X" className="text-gray-500 hover:text-white transition-colors">
      <span className='font-bold'>X</span>
    </a>
    <a href="https://no.pinterest.com/artrewards/" aria-label="Pinterest"  title="pinterest" target="_blank" className="text-gray-500 hover:text-white transition-colors">
      <FaPinterestP className="text-lg" />
    </a>
    <a href="https://www.tumblr.com/artrewards" aria-label="Tumblr"   title="tumblr" target="_blank" className="text-gray-500 hover:text-white transition-colors">
      <FaTumblr className="text-lg" />
    </a>
    <a href="https://www.artsy.net/partner/artrewards" aria-label="Artsy" target="_blank" className="text-gray-500 hover:text-white transition-colors">
      <img 
        src="/artsy1.png" 
        alt="Artsy" 
        title="Artsy"
        className="h-5 w-auto opacity-70 hover:opacity-100 transition-all"
      />
    </a>
  </div>
);

const Footer = () => {
  return (
    <footer className="bg-black py-24 border-t border-gray-800">
      <div className="w-full px-8 md:px-12">
        
        <div className="grid grid-cols-12 gap-y-10 lg:gap-x-12 mb-16 lg:mb-24">
          
          <div className="col-span-12 lg:col-span-3 order-1">
            <Link to="/" className="block mb-6">
              <img 
                src="/logo4.png" 
                alt="ArtRewards" 
                className="h-14"
              />
            </Link>
            <span className="text-[#9CA3AF] italic font-serif text-base block mb-6 lg:mb-0">
              Where discernment meets acquisition
            </span>
            <SocialIcons className="flex items-center gap-7 lg:hidden" />
          </div>

          {/* 2. About Section */}
          <div className="col-span-12 lg:col-span-2 order-2">
            <h4 className="text-xs font-medium mb-8 tracking-widest uppercase text-[#4B5563]">
              About
            </h4>
            <ul className="space-y-5">
              <li>
                <Link to="/about" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  About ArtRewards
                </Link>
              </li>
              <li>
                <Link to="/partnership" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  Partnership with Artsy
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  Help Center
                </Link>
              </li>
            </ul>
          </div>

          {/* 3. Explore Section */}
          <div className="col-span-12 lg:col-span-2 order-3">
            <h4 className="text-xs font-medium mb-8 tracking-widest uppercase text-[#4B5563]">
              Explore
            </h4>
            <ul className="space-y-5">
              <li>
                <Link to="/collections" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  Curated Collections
                </Link>
              </li>
              <li>
                <Link to="/artists" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  Featured Artists
                </Link>
              </li>
              <li>
                <Link to="/exhibitions" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  Exhibitions
                </Link>
              </li>
              <li>
                <Link to="/editorial" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  Editorial
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-span-12 lg:col-span-2 order-4">
            <h4 className="text-xs font-medium mb-8 tracking-widest uppercase text-[#4B5563]">
              Inspiration
            </h4>
            <ul className="space-y-5">
              <li>
                <Link to="/studio" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  In the Studio
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-sm text-[#9CA3AF] hover:text-white transition-colors">
                  Artist Resources
                </Link>
              </li>
            </ul>
          </div>

          {/* 5. Newsletter Section */}
          <div className="col-span-12 lg:col-span-3 order-5 mt-4 lg:mt-0"> 
            <h4 className="text-xs font-medium mb-8 tracking-widest uppercase text-[#4B5563]">
              Newsletter
            </h4>
            <p className="text-sm text-[#9CA3AF] mb-6 leading-relaxed">
              Discover the world of fine art.
            </p>
            <form className="flex flex-col gap-3">
              <input 
                type="email" 
                name="email" 
                placeholder="Email address"
                className="px-5 py-3 border border-gray-800 text-sm focus:outline-none focus:border-gray-600 bg-[#111827] text-white placeholder-gray-500 transition-colors"
              />
              <button 
                type="submit"
                className="bg-white text-black px-8 py-3 text-sm tracking-wide hover:bg-gray-200 transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-12">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
            {/* Left side - Copyright and Links */}
            <div className="flex flex-col sm:flex-row items-center gap-x-10 gap-y-4 text-sm text-[#9CA3AF]">
              <span>© 2025 ArtRewards</span>
              <span className="hidden lg:block text-gray-700">|</span>
              <div className="flex items-center gap-x-10">
                <a 
                  href="http://localhost:3000/terms-of-service" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Terms of Service
                </a>
                <a 
                  href="http://localhost:3000/privacy-policy" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </div>
            </div>

            {/* Right side - Social Icons (Desktop only) */}
            <SocialIcons className="hidden lg:flex items-center gap-7" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;